import { COOKIE_CONSENT_KEY } from '../i18n';

export const CONSENT_VERSION = 3;

export type CookieConsent = {
  v: typeof CONSENT_VERSION;
  savedAt: string;
};

export function getConsent(): CookieConsent | null {
  const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as CookieConsent;
    if (parsed?.v === CONSENT_VERSION && typeof parsed.savedAt === 'string') {
      return parsed;
    }
  } catch {}

  if (raw === 'essential' || raw === 'all') {
    return { v: CONSENT_VERSION, savedAt: new Date().toISOString() };
  }

  return null;
}

export function hasValidConsent(): boolean {
  return getConsent() !== null;
}

export function saveConsent(): CookieConsent {
  const consent: CookieConsent = {
    v: CONSENT_VERSION,
    savedAt: new Date().toISOString(),
  };
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
  return consent;
}

export function clearConsent(): void {
  localStorage.removeItem(COOKIE_CONSENT_KEY);
}
